import React, { Component } from 'react';
import { Wrapper, Left, Logo, HeaderText, Right, Signout, SubHeaderText } from './components';
import { AuthContext } from '../../contexts/auth';
import Heart from '../../assets/white.svg';
import HeartDark from '../../assets/pink.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt, faSun, faMoon } from '@fortawesome/free-solid-svg-icons';


class Nav extends Component {
	render() {
		let right;
		if (localStorage.getItem('username')) {
			right = (
				<Right>
					<FontAwesomeIcon
						icon={this.props.theme === 'dark' ? faSun : faMoon}
						onClick={() => this.props.toggleTheme()}
						style={{ cursor: 'pointer' }}
					/>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<Signout
						theme={this.props.theme}
						onClick={() => {
							window.localStorage.removeItem('id_token');
							window.localStorage.removeItem('refresh_token');
							window.localStorage.removeItem('email');
							window.localStorage.removeItem('username');
							window.location = auth.logoutURL
						}}
					>
						<SubHeaderText>
							sign out
					</SubHeaderText>
						<FontAwesomeIcon icon={faSignOutAlt} />
					</Signout>
				</Right>
			)
		} else {
			right = null;
		}
		const auth = this.context;
		return (
			<Wrapper theme={this.props.theme}>
				<Left theme={this.props.theme}>
					<Logo onClick={() => window.location = '/'}>
						<img src={this.props.theme === 'light' ? Heart : HeartDark} alt="logo" />
					</Logo>
					<HeaderText onClick={() => window.location = '/'}>
						Open Health Board
					</HeaderText>
				</Left>
				{right}
			</Wrapper>
		);
	}
};

Nav.contextType = AuthContext;
export default Nav;

